'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.services.serverRouter', ['bsInjularLiveDemo.deps.minimatch', 'bsInjularLiveDemo.deps.fileChanger', 'bsInjularLiveDemo.services.fileSystem', 'bsInjularLiveDemo.services.project']);
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.services.serverRouter').factory('serverRouter', serverRouterFactory);

  function serverRouterFactory(match, fileChanger, fileSystem, project) {
    var _blobUrlCache = new Map();

    var serverRouter = {
      _blobUrlCache: _blobUrlCache,
      getBlobUrl: getBlobUrl,
      getFile: getFile,
      getFileContent: getFileContent
    };

    fileSystem.events.on('postModify', removeFileCache);
    fileSystem.events.on('postRename', renameFileCache);
    fileSystem.events.on('postDelete', removeFileCache);

    return serverRouter;

    function getFile(url) {
      var file = fileSystem.getFile(url).copy();
      if (file.file) return file;
      var content = file.content;
      var injSettings = project.settings.injular;
      if (match(url, injSettings.templates)) {
        content = fileChanger.wrapTemplate(content, url);
      } else if (match(url, injSettings.directives)) {
        content = fileChanger.wrapDirectiveFile(content, url);
      } else if (match(url, injSettings.moduleFile)) {
        content = fileChanger.appendProvideGetter(content, injSettings.ngApp);
      } else if (match(url, injSettings.angularFile)) {
        content = fileChanger.appendAngularModulePatch(content);
      }
      file.content = content;
      return file;
    }

    function getFileContent(url) {
      return serverRouter.getFile(url).content;
    }

    function getBlobUrl(url) {
      var blobUrl = _blobUrlCache.get(url);
      if (!blobUrl) {
        var file = serverRouter.getFile(url);
        var blob = void 0;
        if (file.file) {
          blob = file.file;
        } else {
          var content = file.content;
          var type = file.type;
          blob = new Blob([content], { type: type });
        }
        blobUrl = URL.createObjectURL(blob);
        _blobUrlCache.set(url, blobUrl);
      }
      return blobUrl;
    }

    function removeFileCache(file) {
      var blobUrl = _blobUrlCache.get(file.name);
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
        _blobUrlCache.delete(file.name);
      }
    }

    function renameFileCache(newFile, oldFile) {
      removeFileCache(oldFile);
      serverRouter.getBlobUrl(newFile.name);
    }
  }
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.services.projectCreator', ['bsInjularLiveDemo.services.project', 'bsInjularLiveDemo.services.fileSystem',

  // listen to fileSystem events:
  'bsInjularLiveDemo.services.editor', 'bsInjularLiveDemo.services.serverRouter', 'bsInjularLiveDemo.services.liveDemo'])
  /* eslint-disable no-unused-vars */
  .run(function (editor, serverRouter, liveDemo) {});
  /* eslint-enable no-unused-vars */
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.services.projectCreator').factory('projectCreator', projectCreatorFactory);

  function projectCreatorFactory($http, $log, project, fileSystem) {
    var projectCreator = {
      blank: blank,
      githubGist: githubGist
    };

    return projectCreator;

    function blank() {
      var origin = 'blank';
      if (project.origin === origin) return;
      project.origin = origin;
      project.startLoading();
      fileSystem.createFile('index.html', '<!doctype html>\n<html>\n  <head>\n    <meta charset="utf-8">\n    <style>[ng-cloak] { display: none; }</style>\n  </head>\n  <body ng-app="app">\n    <!--\n    <script src="//ajax.googleapis.com/ajax/libs/angularjs/1.5.8/angular.js"></script>\n    -->\n  </body>\n</html>\n');
      project.doneLoading();
    }

    function githubGist(id) {
      var origin = 'gh-gist_' + id;
      if (project.origin === origin) return;
      project.origin = origin;
      project.startLoading();
      return $http.get('https://api.github.com/gists/' + id).then(function (response) {
        var files = response.data.files;
        for (var fileName in files) {
          var file = files[fileName];
          fileSystem.createFile(fileName, file.content, file.type);
        }
        project.doneLoading();
      }, function (errResponse) {
        $log.error(errResponse);
      });
    }
  }
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.services.project', ['bsInjularLiveDemo.deps.EventEmitter', 'bsInjularLiveDemo.services.fileSystem']);
})();


'use strict';

(function () {
  'use strict';

  var PROJECT_SETTINGS_FILENAME = '.injular.json';

  angular.module('bsInjularLiveDemo.services.project').factory('project', projectFactory);

  function projectFactory(EventEmitter, fileSystem) {
    var project = {
      get SETTINGS_FILENAME() {
        return PROJECT_SETTINGS_FILENAME;
      },
      origin: null,
      loading: false,
      startLoading: startLoading,
      doneLoading: doneLoading,
      events: new EventEmitter()
    };
    resetSettings();

    fileSystem.events.on('postCreate', fileChangeListener);
    fileSystem.events.on('postModify', fileChangeListener);
    fileSystem.events.on('preRename', filePredeleteListener);
    fileSystem.events.on('preDelete', filePredeleteListener);

    return project;

    function fileChangeListener(file) {
      if (file.name === PROJECT_SETTINGS_FILENAME) {
        project.events.emitEvent('preModifySettings');
        project.settings = JSON.parse(file.content);
        if (!project.settings.injular) {
          project.settings.injular = {};
        }
        project.events.emitEvent('postModifySettings');
      }
    }

    function filePredeleteListener(newFile, oldFile) {
      var file = oldFile || newFile;
      if (file.name === PROJECT_SETTINGS_FILENAME && !project.loading) {
        throw new Error(PROJECT_SETTINGS_FILENAME + ' file cannot be deleted');
      }
    }

    function startLoading() {
      project.loading = true;
      fileSystem.clear();
      resetSettings();
    }

    function doneLoading() {
      autoAddSettingsFile();
      project.loading = false;
      project.events.emitEvent('init');
    }

    function resetSettings() {
      project.settings = { injular: {} };
    }

    function autoAddSettingsFile() {
      if (!fileSystem.hasFile(project.SETTINGS_FILENAME)) {
        var settings = {
          entryFile: 'index.html',
          injular: {
            templates: '**/!(index).html',
            controllers: '**/*.controller?(s).js',
            directives: '**/*.+(directive?(s)|component?(s)).js',
            filters: '**/*.filter?(s).js',
            angularFile: '**/angular?(.min).js',
            moduleFile: '**/+(app|index)?(.module).js'
          },
          fileOrder: ['.injular.json']
        };
        var content = JSON.stringify(settings, null, 2);
        fileSystem.createFile(project.SETTINGS_FILENAME, content);
      }
    }
  }
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.services.liveDemo', ['bsInjularLiveDemo.deps.EventEmitter', 'bsInjularLiveDemo.deps.minimatch', 'bsInjularLiveDemo.deps.injular', 'bsInjularLiveDemo.deps.fileChanger', 'bsInjularLiveDemo.services.fileSystem', 'bsInjularLiveDemo.services.serverRouter', 'bsInjularLiveDemo.services.project']);
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.services.liveDemo').factory('liveDemo', liveDemoFactory);

  function liveDemoFactory($log, $window, EventEmitter, match, injular, fileChanger, fileSystem, serverRouter, project) {
    var domain = $window.location.protocol + '//' + $window.location.host;

    var liveDemo = {
      events: new EventEmitter(),
      setIframe: setIframe,
      reload: reload,
      _replaceDocument: _replaceDocument
    };

    fileSystem.events.on('postCreate', fileModifiedListener);
    fileSystem.events.on('postRename', fileModifiedListener);
    fileSystem.events.on('postModify', fileModifiedListener);
    fileSystem.events.on('postDelete', _reloadFn);

    project.events.on('init', _reloadFn);
    project.events.on('postModifySettings', _reloadFn);

    return liveDemo;

    function setIframe($iframe) {
      var _this = this;

      if (this.$iframe === $iframe) return;
      this.$iframe = $iframe;
      this._injular = null;
      this._window = null;
      if (!$iframe) return;
      this._window = $iframe[0].contentWindow;
      if (!this._window) {
        throw new Error('Iframe does not have a window');
      }
      this.$iframe.on('load', function () {
        if ($iframe === _this.$iframe) {
          _this._window = _this.$iframe[0].contentWindow;
          _this._replaceDocument();
        }
      });
    }

    function reload() {
      if (!this._window) return;
      if (project.loading) {
        this._window.document.body.textContent = 'Loading...';
      } else {
        this._window.location.replace('about:blank');
        this._injular = null;
      }
    }

    function _reloadFn() {
      liveDemo.reload();
    }

    function fileModifiedListener(file) {
      var settings = project.settings;
      if (!liveDemo._injular) {
        liveDemo.reload();
      } else if (match(file.name, settings.injular.templates)) {
        var content = serverRouter.getFileContent(file.name);
        liveDemo._injular.injectTemplate({
          template: content,
          templateUrl: file.name,
          reloadRoute: settings.injular.reloadRouteOnTemplateInjection,
          avoidCleanScope: settings.injular.avoidCleanScope,
          logLevel: settings.logLevel
        });
      } else {
        var recipes = getNgRecipes(file.name);
        if (recipes.length) {
          liveDemo._injular.injectScript({
            script: file.content,
            scriptUrl: file.name,
            recipes: recipes,
            logLevel: settings.logLevel
          });
        } else {
          liveDemo.reload();
        }
      }
    }

    function _replaceDocument() {
      if (project.settings.entryFile) {
        var win = this._window;
        var doc = win.document.open();
        this.events.emitEvent('preReplaceDocument');
        injular.newInstance(win, doc);
        this._injular = win.injular;
        delete win.injular;
        win.___setUpSinonFakeRequest = getSetUpSinonFakeRequestFn(win);
        var html = getDocumentHtmlString();
        doc.write(html);
        doc.close();
        observerDomMutation(doc);
        this.events.emitEvent('postReplaceDocument');
      }
    }

    function getNgRecipes(name) {
      var injSettings = project.settings.injular;
      var recipes = [];
      if (match(name, injSettings.controllers)) {
        recipes.push('controller');
      } else if (match(name, injSettings.directives)) {
        recipes.push('directive');
      } else if (match(name, injSettings.filters)) {
        recipes.push('filter');
      }
      return recipes;
    }

    function getDocumentHtmlString() {
      var entryFile = project.settings.entryFile;
      try {
        var initialHtml = serverRouter.getFileContent(entryFile);
        var doc = htmlToDom(initialHtml);
        modifyDocumentScriptsSrc(doc);
        modifyDocumentLinksHref(doc);
        modifyDocumentImgsSrc(doc);
        prependSinonFakeRequest(doc);
        return getDoctypeHtml(doc) + doc.documentElement.outerHTML;
      } catch (err) {
        $log.error(err);
        return '<p style="color:red">' + err + '</p>';
      }
    }

    function htmlToDom(content) {
      var doc = document.implementation.createHTMLDocument();
      doc.open();
      doc.write('<base href="/">\n' + content);
      doc.close();
      return doc;
    }

    function modifyDocumentScriptsSrc(doc) {
      var scripts = doc.scripts;
      for (var i = 0; i < scripts.length; i++) {
        var script = scripts[i];
        var src = script.src;
        if (src.startsWith(domain) && script.getAttribute('src')) {
          var srcPath = src.slice(domain.length + 1);
          var blobUrl = serverRouter.getBlobUrl(srcPath);
          script.setAttribute('injular-src', src);
          script.setAttribute('src', blobUrl);
        } else if (match(src, project.settings.injular.angularFile)) {
          var newScript = doc.createElement('script');
          newScript.text = fileChanger.appendAngularModulePatch('');
          script.parentNode.insertBefore(newScript, script.nextSibling);
        }
      }
    }

    function modifyDocumentLinksHref(doc) {
      var links = doc.getElementsByTagName('link');
      for (var i = 0; i < links.length; i++) {
        var link = links[i];
        var href = link.href;
        if (String.prototype.startsWith.call(href, domain)) {
          var path = href.slice(domain.length);
          if (path.startsWith('/')) {
            path = path.slice(1);
          }
          var blobUrl = serverRouter.getBlobUrl(path);
          link.setAttribute('href', blobUrl);
        }
      }
    }

    function modifyDocumentImgsSrc(doc) {
      var imgs = doc.getElementsByTagName('img');
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        blobifyImgSrc(img);
      }
    }

    function prependSinonFakeRequest(doc) {
      if (liveDemo._noRequests) return;
      var sinonFilterScriptElement = doc.createElement('script');
      sinonFilterScriptElement.text = 'window.___setUpSinonFakeRequest();delete window.___setUpSinonFakeRequest;delete window.sinon;';
      doc.head.insertBefore(sinonFilterScriptElement, doc.head.firstChild);

      var sinonScriptElement = doc.createElement('script');
      sinonScriptElement.setAttribute('src', 'assets/sinon-server-1.17.3.js');
      doc.head.insertBefore(sinonScriptElement, doc.head.firstChild);
    }

    function observerDomMutation(doc) {
      if (typeof MutationObserver === 'undefined') return;
      var observer = new MutationObserver(callback);
      var config = { attributes: true, childList: true, subtree: true };
      observer.observe(doc, config);

      var createElement = doc.createElement;
      doc.createElement = observeCreateElement;

      function callback(mutations) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var mutation = _step.value;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = mutation.addedNodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var node = _step2.value;

                blobifyImgSrc(node);
                var tw = document.createTreeWalker(node, NodeFilter.SHOW_ELEMENT, function (node) {
                  if (node.tagName === 'IMG') {
                    return NodeFilter.FILTER_ACCEPT;
                  }
                  return NodeFilter.FILTER_SKIP;
                });
                while (node = tw.nextNode()) {
                  blobifyImgSrc(node);
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            if (mutation.attributeName === 'src') {
              blobifyImgSrc(mutation.target);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      function observeCreateElement() {
        var el = createElement.apply(this, arguments);
        observer.observe(el, config);
        return el;
      }
    }

    function blobifyImgSrc(node) {
      var src = node.src || '';
      if (String.prototype.startsWith.call(src, domain)) {
        var path = src.slice(domain.length);
        if (path.startsWith('/')) {
          path = path.slice(1);
        }
        var blobUrl = serverRouter.getBlobUrl(path);
        node.setAttribute('src', blobUrl);
        node.setAttribute('injular-src', src);
      }
    }

    function getSetUpSinonFakeRequestFn(win) {
      return setUpSinonFakeRequest;

      function setUpSinonFakeRequest() {
        var anchor = win.document.createElement('a');
        var server = win.sinon.fakeServer.create();
        server.xhr.useFilters = true;
        server.xhr.addFilter(filter);
        server.respondWith(respondWith);
        server.autoRespond = true;
        var scripts = win.document.scripts;
        win.document.head.removeChild(scripts[1]);
        win.document.head.removeChild(scripts[0]);

        function filter(method, url) {
          try {
            getLocalFileFromUrl(url);
            return false;
          } catch (err) {
            return true;
          }
        }

        function respondWith(xhr) {
          var headers = {};
          var localFile = getLocalFileFromUrl(xhr.url);
          if (localFile.type) {
            headers['Content-Type'] = localFile.type;
          }
          xhr.respond(200, headers, localFile.content);
        }

        function getLocalFileFromUrl(url) {
          anchor.href = url;
          var href = anchor.href;
          if (href.startsWith(domain)) {
            var fileName = href.slice(domain.length + 1);
            return serverRouter.getFile(fileName);
          }
        }
      }
    }

    function getDoctypeHtml(doc) {
      var node = doc.doctype;
      if (!node) return '';
      return "<!DOCTYPE " + node.name + (node.publicId ? ' PUBLIC "' + node.publicId + '"' : '') + (!node.publicId && node.systemId ? ' SYSTEM' : '') + (node.systemId ? ' "' + node.systemId + '"' : '') + '>\n';
    }
  }
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.services.fileSystem', ['bsInjularLiveDemo.deps.EventEmitter', 'bsInjularLiveDemo.services.MemoryFile']);
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.services.fileSystem').factory('fileSystem', fileSystemFactory);

  function fileSystemFactory(EventEmitter, MemoryFile) {
    var fileSystem = {
      createFile: createFile,
      readFile: readFile,
      getFile: getFile,
      getFileType: getFileType,
      getFiles: getFiles,
      hasFile: hasFile,
      modifyFile: modifyFile,
      renameFile: renameFile,
      deleteFile: deleteFile,
      clear: clear,
      events: new EventEmitter()
    };

    var fileMap = new Map();

    return fileSystem;

    function createFile(name) {
      var content = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
      var type = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

      var file = new MemoryFile(name, content, type);
      name = file.name;
      if (fileMap.has(name)) {
        throw new Error('File already exists: ' + name);
      }
      Object.freeze(file);
      fileSystem.events.emitEvent('preCreate', [file]);
      fileMap.set(name, file);
      fileSystem.events.emitEvent('postCreate', [file]);
      return file;
    }

    function readFile(name) {
      return getFile(name).content;
    }

    function getFile(name) {
      var file = fileMap.get(name);
      if (!file) {
        throw new Error('File does not exists: ' + name);
      }
      return file;
    }

    function getFileType(name) {
      return getFile(name).type;
    }

    function getFiles() {
      return fileMap.values();
    }

    function hasFile(name) {
      return fileMap.has(name);
    }

    function modifyFile(name, content) {
      var file = fileMap.get(name);
      if (!file) {
        throw new Error('File does not exists: ' + name);
      }
      if (typeof content === 'undefined') {
        throw new Error('Content is needed when modifying file: ' + name);
      }
      var newFile = new MemoryFile(name, content, file.type);
      Object.freeze(newFile);
      fileSystem.events.emitEvent('preModify', [newFile, file]);
      fileMap.set(name, newFile);
      fileSystem.events.emitEvent('postModify', [newFile, file]);
    }

    function renameFile(name, newName) {
      var file = fileMap.get(name);
      if (!file) {
        throw new Error('File does not exists: ' + name);
      }
      if (name === newName) {
        return;
      }
      if (fileMap.has(newName)) {
        throw new Error('File already exists: ' + name);
      }
      var newFile = file.copy();
      newFile.rename(newName);
      Object.freeze(newFile);
      fileSystem.events.emitEvent('preRename', [newFile, file]);
      fileMap.delete(name);
      fileMap.set(newName, newFile);
      fileSystem.events.emitEvent('postRename', [newFile, file]);
      return newFile;
    }

    function deleteFile(name) {
      var file = fileMap.get(name);
      if (!file) {
        throw new Error('File does not exists: ' + name);
      }
      fileSystem.events.emitEvent('preDelete', [file]);
      fileMap.delete(name);
      fileSystem.events.emitEvent('postDelete', [file]);
    }

    function clear() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = fileMap.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var fileName = _step.value;

          fileSystem.deleteFile(fileName);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.services.editor', ['bsInjularLiveDemo.deps.EventEmitter', 'bsInjularLiveDemo.deps.ace', 'bsInjularLiveDemo.services.fileSystem', 'bsInjularLiveDemo.services.project']);
})();


'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.services.editor').factory('editor', editorFactory);

  function editorFactory($timeout, EventEmitter, ace, fileSystem, project) {
    var aceModelist = ace.require('ace/ext/modelist');
    var settings = {
      autoSave: true,
      delayedAutoSaveDelay: 1000,
      instantAutoSaveDelay: 80
    };
    var fileList = [];
    var fileMap = new Map();
    var delayedAutoSaveFileSet = new Set();
    var instantAutoSaveFileSet = new Set();
    var timeouts = {
      delayedAutoSave: null,
      instantAutoSave: null
    };

    var editor = {
      activeFile: null,
      settings: settings,
      fileList: fileList,
      fileMap: fileMap,
      changeActiveFile: changeActiveFile,
      fileContentChanged: fileContentChanged,
      events: new EventEmitter()
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = fileSystem.getFiles()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var fsFile = _step.value;

        addFile(fsFile);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    fileSystem.events.on('postCreate', addFile);
    // fileSystem.events.on('postModify', fileModifiedListener);
    fileSystem.events.on('postRename', renameFile);
    fileSystem.events.on('postDelete', deleteFile);

    project.events.on('postModifySettings', projectSettingsModifiedListener);
    project.events.on('init', projectInitListener);

    return editor;

    function fileContentChanged(file) {
      var fileSet = void 0,
          timeoutName = void 0,
          delay = void 0;
      var name = file.name;
      if (name.endsWith('.js') || name === project.SETTINGS_FILENAME || name === project.settings.entryFile) {
        fileSet = delayedAutoSaveFileSet;
        timeoutName = 'delayedAutoSave';
        delay = settings.delayedAutoSaveDelay;
      } else {
        fileSet = instantAutoSaveFileSet;
        timeoutName = 'instantAutoSave';
        delay = settings.instantAutoSaveDelay;
      }
      $timeout.cancel(timeouts[timeoutName]);
      fileSet.add(name);
      timeouts[timeoutName] = $timeout(saveFileChanges, delay);

      function saveFileChanges() {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = fileSet.values()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var fileName = _step2.value;

            var setFile = fileMap.get(fileName);
            fileSystem.modifyFile(setFile.name, setFile.content);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        fileSet.clear();
      }
    }

    function aceChangeListener(change, file) {
      fileContentChanged(file);
    }

    function addFile(fsFile) {
      var file = void 0;
      if (fsFile.file) {
        file = createRawFile(fsFile);
      } else {
        file = createAceFile(fsFile);
      }
      fileMap.set(file.name, file);
      fileList.push(file);
      reorderFileList();
      editor.changeActiveFile(file.name);
    }

    function createAceFile(fsFile) {
      var mode = aceModelist.getModeForPath(fsFile.name).mode;
      var file = ace.createEditSession(fsFile.content, mode);
      file.name = fsFile.name;
      Object.defineProperty(file, 'content', {
        get: function get() {
          return file.doc.getValue();
        },
        set: function set(val) {
          return file.doc.setValue(val);
        }
      });
      disableEditorWarnings(file);
      file.on('change', aceChangeListener);
      return file;
    }

    function createRawFile(fsFile) {
      return fsFile.copy();
    }

    function disableEditorWarnings(file) {
      file.on('changeAnnotation', function () {
        if (file.name.endsWith('.html') && file.name !== project.settings.entryFile) {
          var annotations = file.getAnnotations();
          var len = annotations.length;
          var i = len;
          while (i--) {
            if (/doctype first\. Expected/.test(annotations[i].text)) {
              annotations.splice(i, 1);
            }
          }
          if (annotations.length < len) {
            file.setAnnotations(annotations);
          }
        }
      });
    }

    // function fileModifiedListener(file) {
    // }

    function renameFile(newFile, oldFile) {
      var newName = newFile.name;
      var oldName = oldFile.name;
      var file = fileMap.get(oldName);
      fileMap.delete(oldName);
      file.name = newName;
      var mode = aceModelist.getModeForPath(newName).mode;
      file.setMode(mode);
      fileMap.set(file.name, file);
      reorderFileList();

      if (delayedAutoSaveFileSet.delete(oldName)) {
        delayedAutoSaveFileSet.put(newName);
      }
      if (instantAutoSaveFileSet.delete(oldName)) {
        instantAutoSaveFileSet.put(newName);
      }
    }

    function deleteFile(fsFile) {
      fileMap.delete(fsFile.name);
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = fileList.entries()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _step3$value = _slicedToArray(_step3.value, 2);

          var index = _step3$value[0];
          var file = _step3$value[1];

          if (file.name === fsFile.name) {
            fileList.splice(index, 1);
            delayedAutoSaveFileSet.delete(file.name);
            instantAutoSaveFileSet.delete(file.name);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var firstFile = editor.fileList[0];
      editor.changeActiveFile(firstFile ? firstFile.name : null);
    }

    function projectSettingsModifiedListener() {
      reorderFileList();
    }

    function projectInitListener() {
      var firstFile = editor.fileList[0];
      editor.changeActiveFile(firstFile ? firstFile.name : null);
    }

    function reorderFileList() {
      var fileOrder = project.settings.fileOrder || [];
      fileList.sort(function (left, right) {
        var leftIndex = fileOrder.indexOf(left.name);
        var rightIndex = fileOrder.indexOf(right.name);
        if (leftIndex < 0) leftIndex = fileOrder.length;
        if (rightIndex < 0) rightIndex = fileOrder.length;
        var order = leftIndex - rightIndex;
        if (order === 0) {
          order = left.name <= right.name ? -1 : 1;
        }
        return order;
      });
    }

    function changeActiveFile(fileName) {
      var file = null;
      if (fileName) {
        file = fileMap.get(fileName);
        if (!file) {
          throw new Error('File ' + fileName + ' is not in editor');
        }
      }
      var prevFile = editor.activeFile;
      editor.events.emitEvent('preActiveFileChange', [file, prevFile]);
      editor.activeFile = file;
      editor.events.emitEvent('postActiveFileChange', [file, prevFile]);
    }
  }
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.services.MemoryFile', ['bsInjularLiveDemo.deps.createNativeFile', 'bsInjularLiveDemo.services.mimeType']);
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.services.MemoryFile').factory('MemoryFile', MemoryFileFactory);

  function MemoryFileFactory(createNativeFile, mimeType) {
    MemoryFile.prototype.copy = copy;
    MemoryFile.prototype.rename = rename;

    return MemoryFile;

    function MemoryFile(name) {
      var content = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
      var type = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

      if (name instanceof Blob) {
        var file = name;
        this.name = file.name;
        this.file = file;
        this.type = file.type || mimeType.lookup(file.name);
      } else {
        this.name = name;
        this.content = content;
        this.type = type || mimeType.lookup(name);
      }
      if (!this.name) {
        throw new Error('Name is missing');
      }
    }

    function copy() {
      return new MemoryFile(this.file || this.name, this.content, this.type);
    }

    function rename(newName) {
      var file = this.file;
      if (file) {
        var newFile = createNativeFile([file], newName, {
          type: file.type,
          lastModified: file.lastModified
        });
        this.file = newFile;
      }
      this.name = newName;
    }
  }
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.directives.liveDemoIframe', ['bsInjularLiveDemo.services.liveDemo']);
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.directives.liveDemoIframe').directive('liveDemoIframe', liveDemoIframeDirective);

  function liveDemoIframeDirective(liveDemo) {
    return {
      restrict: 'A',
      link: link
    };

    function link(scope, element) {
      liveDemo.setIframe(element);
      liveDemo.reload();

      scope.$on('$destroy', function () {
        liveDemo.setIframe(null);
      });
    }
  }
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.directives.addMovingSplitbarClass', ['ui.layout']);
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.directives.addMovingSplitbarClass').directive('addMovingSplitbarClass', addMovingSplitbarClassDirective);

  function addMovingSplitbarClassDirective() {
    return {
      restrict: 'A',
      require: 'uiLayout',
      link: link
    };

    function link(scope, element, attrs, uiLayoutCtrl) {
      var processSplitbar = uiLayoutCtrl.processSplitbar;
      var mouseUpHandler = uiLayoutCtrl.mouseUpHandler;

      uiLayoutCtrl.processSplitbar = processSplitbarAlt;
      uiLayoutCtrl.mouseUpHandler = mouseUpHandlerAlt;

      function processSplitbarAlt(container) {
        if (uiLayoutCtrl.movingSplitbar) {
          attrs.$addClass('moving-splitbar');
          uiLayoutCtrl.movingSplitbar.element.addClass('-moving');
        }
        return processSplitbar(container);
      }

      function mouseUpHandlerAlt(event) {
        if (uiLayoutCtrl.movingSplitbar) {
          uiLayoutCtrl.movingSplitbar.element.removeClass('-moving');
        }
        attrs.$removeClass('moving-splitbar');
        return mouseUpHandler(event);
      }
    }
  }
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.directives.aceModelManager', ['bsInjularLiveDemo.deps.ace', 'bsInjularLiveDemo.services.editor']);
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.directives.aceModelManager').directive('aceModelManager', aceModelManagerDirective);

  function aceModelManagerDirective($timeout, ace, editor) {
    return {
      restrict: 'A',
      link: postLink
    };

    function postLink($scope, $element, $attrs) {
      var acee = ace.edit($element[0]);
      window.acee = acee;
      acee.$blockScrolling = Infinity;

      editor.events.on('postActiveFileChange', postEditorActiveFileChangeListener);

      $scope.$on('$destroy', destroyListener);
      postEditorActiveFileChangeListener();
      $scope.$eval($attrs.aceModelManagerOnLoad, { $acee: acee });

      function postEditorActiveFileChangeListener() {
        var activeFile = editor.activeFile;
        var newSession = null;
        if (activeFile && !activeFile.file) {
          newSession = activeFile;
        }
        acee.setSession(newSession);
        acee.focus();
      }

      function destroyListener() {
        editor.events.off('postActiveFileChange', postEditorActiveFileChangeListener);
      }
    }
  }
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.components.editorView', ['ui.layout', 'ngFileUpload', 'filereader', 'bsInjularLiveDemo.deps.ace', 'bsInjularLiveDemo.services.editor', 'bsInjularLiveDemo.services.fileSystem', 'bsInjularLiveDemo.services.projectCreator', 'bsInjularLiveDemo.directives.liveDemoIframe', 'bsInjularLiveDemo.directives.addMovingSplitbarClass', 'bsInjularLiveDemo.directives.aceModelManager']);
})();


'use strict';

(function () {
  'use strict';

  var mobileMaxWidth = 480;

  angular.module('bsInjularLiveDemo.components.editorView').component('editorView', {
    templateUrl: 'app/components/editorView/editorView.html',
    controller: EditorViewController
  });

  function EditorViewController($scope, $window, $timeout, FileReader, ace, editor, fileSystem) {
    var $ctrl = this;

    var uiLayout = {
      flow: 'column',
      disableToggle: true,
      dividerSize: 5
    };
    var collapsed = {
      fileList: false,
      editor: false,
      liveView: false
    };
    var previousCollapsedFileListStatus = void 0;

    angular.extend($ctrl, {
      uiLayout: uiLayout,
      collapsed: collapsed,
      editor: editor,
      aceEditorLoadListener: aceEditorLoadListener,
      changeActiveFile: changeActiveFile,
      toggleEditorCollapse: toggleEditorCollapse,
      showNewFilePrompt: showNewFilePrompt,
      showRenameFilePrompt: showRenameFilePrompt,
      importFiles: importFiles,
      removeFile: removeFile
    });

    activate();

    function activate() {
      if ($window.outerWidth <= mobileMaxWidth) {
        uiLayout.dividerSize = 10;
        $ctrl.hideOutputMode = true;
      }
      $scope.$on('ui.layout.loaded', function () {
        $timeout(function () {
          if ($window.outerWidth > mobileMaxWidth) {
            collapsed.fileList = false;
            collapsed.editor = false;
            collapsed.liveView = false;
          } else {
            collapsed.fileList = true;
            collapsed.editor = true;
            collapsed.liveView = false;
          }
        });
      });
    }

    function aceEditorLoadListener(acee) {
      setEditorCommands(acee);
    }

    function setEditorCommands(acee) {
      acee.commands.addCommands({
        saveFile: {
          bindKey: {
            win: 'Ctrl-S',
            mac: 'Command-S',
            sender: 'editor|cli'
          },
          exec: function exec() {
            var file = editor.activeFile;
            fileSystem.modifyFile(file.name, file.content);
          }
        },
        newFile: {
          bindKey: {
            win: 'Ctrl-B',
            mac: 'Command-B',
            sender: 'editor|cli'
          },
          exec: function exec() {
            $scope.$apply(function () {
              showNewFilePrompt();
            });
          }
        }
      });
    }

    function showNewFilePrompt() {
      var newFileName = $window.prompt('New filename');
      if (newFileName) {
        fileSystem.createFile(newFileName);
      }
    }

    function showRenameFilePrompt(file) {
      var newFileName = $window.prompt('Rename file', file.name);
      if (newFileName) {
        fileSystem.renameFile(file.name, newFileName);
      }
    }

    function changeActiveFile(file) {
      collapsed.editor = false;
      editor.changeActiveFile(file.name);
    }

    function toggleEditorCollapse() {
      collapsed.editor = !collapsed.editor;
      if (collapsed.editor) {
        previousCollapsedFileListStatus = collapsed.fileList;
        collapsed.fileList = true;
      } else if (!previousCollapsedFileListStatus) {
        collapsed.fileList = false;
      }
    }

    function importFiles(files) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var file = _step.value;

          // TODO use file.path when available
          if (!file.name) {
            // File does not have a name when it is pasted
            var extension = file.type === 'image/png' ? '.png' : '';
            var newName = 'unnamed_file';
            var counter = 1;
            var name = newName + extension;
            while (fileSystem.hasFile(name)) {
              name = newName + '_' + ++counter + extension;
            }
            file.name = name;
          }
          // TODO reserve file name
          FileReader.readAsText(file, undefined, $scope).then(function (data) {
            if (isStringBinary(data)) {
              fileSystem.createFile(file);
            } else {
              fileSystem.createFile(file.name, data, file.type);
            }
          }, function (err) {
            /* eslint-disable no-console */
            console.error(err);
            /* eslint-enable no-console */
          });
        };

        for (var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    function isStringBinary(string) {
      /* eslint-disable no-control-regex */
      return (/[\x00-\x08\x0E-\x1F]/.test(string)
      );
      /* eslint-enable no-control-regex */
    }

    function removeFile(file) {
      var removeConfirmed = $window.confirm('Are you sure that you want to delete ' + file.name + '?');
      if (removeConfirmed) {
        fileSystem.deleteFile(file.name);
      }
    }
  }
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo', ['ngTouch', 'ui.router', 'bsInjularLiveDemo.components.editorView']);
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo').config(routerConfig);

  function routerConfig($urlRouterProvider, $stateProvider) {
    $urlRouterProvider.otherwise('/gh-gist/83f19f04eacc289cd0fc7afedd66559f');

    $stateProvider.state('editor', {
      abstract: true,
      template: '<editor-view></editor-view>'
    }).state('editor.blank', {
      url: '/blank',
      resolve: {
        __init__: function __init__($log, projectCreator) {
          try {
            projectCreator.blank();
          } catch (err) {
            $log.error(err);
          }
        }
      }
    }).state('editor.gh-gist', {
      url: '/gh-gist/:gistId',
      resolve: {
        __init__: function __init__($log, $stateParams, projectCreator) {
          try {
            projectCreator.githubGist($stateParams.gistId);
          } catch (err) {
            $log.error(err);
          }
        }
      }
    });
  }
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo').config(config);

  function config($logProvider) {
    $logProvider.debugEnabled(location.hostname === 'localhost');
  }
})();


'use strict';

(function () {
  'use strict';

  var mimeTypes = Object.create(null);
  angular.extend(mimeTypes, {
    bmp: 'image/bmp',
    css: 'text/css',
    gif: 'image/gif',
    html: 'text/html',
    ico: '  image/x-icon',
    jpe: 'image/jpeg',
    jpeg: 'image/jpeg',
    jpg: 'image/jpeg',
    js: 'application/javascript',
    json: 'application/json',
    png: 'image/png',
    svg: 'image/svg+xml',
    tiff: 'image/tiff',
    webp: 'image/webp',
    xml: 'application/xml'
  });

  angular.module('bsInjularLiveDemo.services.mimeType', [
    // no dependencies
  ]).constant('mimeType', {
    _dict: mimeTypes,
    lookup: lookup
  });

  function lookup(fileName) {
    if (!fileName) return;
    var extensionIndex = fileName.lastIndexOf('.') + 1;
    var extension = fileName.slice(extensionIndex);
    return this._dict[extension];
  }
})();


'use strict';

/* global minimatch */
(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.deps.minimatch', [
    // no dependencies
  ]).constant('minimatch', minimatch).constant('match', match);

  function match(name, pattern) {
    if (!pattern) return false;
    return minimatch(name, pattern);
  }
})();


'use strict';

/* global injular */
(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.deps.injular', [
    // no dependencies
  ]).constant('injular', injular);
})();


'use strict';

/* global fileChanger */
(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.deps.fileChanger', [
    // no dependencies
  ]).constant('fileChanger', fileChanger);
})();


'use strict';

(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.deps.createNativeFile', [
    // no dependencies
  ]).constant('createNativeFile', createNativeFile);

  function createNativeFile(parts, filename) {
    var properties = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

    var file = void 0;
    try {
      file = new File(parts, filename, properties);
    } catch (err) {
      // phantomjs doesn't support FileConstructor
      var date = void 0;
      if ('lastModified' in properties) {
        date = new Date(properties.lastModified);
      } else {
        date = new Date();
      }
      file = new Blob(parts, properties);
      file.name = filename;
      file.lastModified = +date;
      file.lastModifiedDate = date;
    }
    return file;
  }
})();


'use strict';

/* global ace */
(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.deps.ace', [
    // no dependencies
  ]).constant('ace', ace);
})();


'use strict';

/* global EventEmitter */
(function () {
  'use strict';

  angular.module('bsInjularLiveDemo.deps.EventEmitter', [
    // no dependencies
  ]).constant('EventEmitter', EventEmitter);
})();


angular.module("bsInjularLiveDemo").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/editorView/editorView.html","<div class=editor-view ngf-drop=$ctrl.importFiles($files) ngf-multiple=true ngf-drag-over-class=\"\'-dragging-file\'\" ng-model-options=\"{updateOn: \'drop paste\'}\"><div class=topbar><button type=button class=\"btn-clear nav-button\" ng-click=\"$ctrl.collapsed.fileList = !$ctrl.collapsed.fileList\"><i class=\"fa fa-navicon\"></i></button><div class=toggle-panel-buttons><button type=button class=\"btn-clear editor-button\" ng-click=$ctrl.toggleEditorCollapse() ng-class=\"{\'active\': !$ctrl.collapsed.editor}\">Editor</button><!--\n   --><button type=button class=\"btn-clear live-view-button\" ng-click=\"$ctrl.collapsed.liveView = !$ctrl.collapsed.liveView\" ng-class=\"{\'active\': !$ctrl.collapsed.liveView}\">Output</button><label class=hide-mode-label><span></span> <input type=checkbox ng-model=$ctrl.hideOutputMode> <span>Hide mode</span></label></div></div><div class=content ui-layout=$ctrl.uiLayout add-moving-splitbar-class ui-layout-loaded><div class=file-list-wrapper ui-layout-container collapsed=$ctrl.collapsed.fileList size=175px><ul class=file-list><li ng-repeat=\"file in $ctrl.editor.fileList track by file.name\" class=file-list-item ng-class=\"{\'active\': $ctrl.editor.activeFile === file}\"><button type=button class=\"select-file-button btn-clear\" ng-click=$ctrl.changeActiveFile(file) ng-dblclick=$ctrl.showRenameFilePrompt(file)>{{file.name}}</button> <button type=button class=\"remove-file-button btn-clear\" ng-click=$ctrl.removeFile(file)><i class=\"fa fa-remove\" aria-hidden=true></i></button></li><li class=file-list-item><button type=button class=\"file-bar-button select-file-button btn-clear\" ng-click=$ctrl.showNewFilePrompt()><i class=\"fa fa-file-code-o\" aria-hidden=true></i><span>New file</span></button></li></ul></div><div class=editor-wrapper ui-layout-container collapsed=$ctrl.collapsed.editor><div ace-model-manager ace-model-manager-on-load=$ctrl.aceEditorLoadListener($acee) ng-show=!$ctrl.editor.activeFile.file></div><img ng-src={{$ctrl.editor.activeFile.file|ngfDataUrl}} ng-if=$ctrl.editor.activeFile.file></div><div class=live-view-wrapper ui-layout-container collapsed=$ctrl.collapsed.liveView><div class=live-view-overlay></div><iframe id=live-view ng-if=\"!$ctrl.collapsed.liveView || $ctrl.hideOutputMode\" live-demo-iframe ng-src=about:blank></iframe></div></div></div>");}]);